var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIntegration = function SvgEmailIntegration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeDasharray: "2 7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M17.376 27.343C20.543 18.81 28.446 13.41 37 13.017M59.945 33.448A21.93 21.93 0 0 1 54.5 49.552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M44 4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h21a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm3 3.5a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3zM45.5 16a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 0 3H47a1.5 1.5 0 0 1-1.5-1.5m1.5 6.5a1.5 1.5 0 0 0 0 3h12a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.688,
    height: 32.874,
    x: 5,
    y: 33,
    fill: "#B4CFFF",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M29.046 51.273a2 2 0 0 1-2.404 0L5.309 35.229A2 2 0 0 1 5 34.947L5 35v28.874a2 2 0 0 0 2 2h41.688a2 2 0 0 0 2-2V34.947q-.135.15-.309.282z",
    clipRule: "evenodd"
  })));
};
export default SvgEmailIntegration;